import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { hostHasTags } from "./checkRowsHostData";

const TagsHostView = ({ entityData }) => {
  const rows = [];
  if (entityData?.kandji_data?.tags) {
    rows.push({
      id: "kandji",
      source: "kandji",
      tags: entityData.kandji_data.tags,
      isKeyValue: false,
    });
  }
  if (entityData?.qualys_data?.tags) {
    rows.push({
      id: "qualys",
      source: "qualys",
      tags: entityData.qualys_data.tags,
      isKeyValue: false,
    });
  }
  if (entityData?.microsoft_defender_data?.machine_tags) {
    rows.push({
      id: "microsoft_defender_endpoint",
      source: "microsoft_defender_endpoint",
      tags: entityData.microsoft_defender_data.machine_tags,
      isKeyValue: false,
    });
  }

  return (
    hostHasTags(entityData) && (
      <Box display={"flex"} flexDirection={"column"} gap={2}>
        {rows.map((row) => (
          <Box key={row.id} display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <IntegrationImage
                name={row.source}
                width={"16px"}
                newLogo={true}
              />
              <Typography variant="subtitle2">Tags</Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {row.isKeyValue
                ? // Key-value tags
                  row.tags.map((tagObj, index) => (
                    <Box
                      key={index}
                      display={"flex"}
                      flexDirection={"column"}
                      gap={1}
                    >
                      {Object.entries(tagObj).map(([key, value]) => (
                        <TextIntegrationStyle
                          key={key}
                          title={key}
                          value={value}
                        ></TextIntegrationStyle>
                      ))}
                    </Box>
                  ))
                : // Simple list tags
                  row.tags.map((tag, index) => (
                    <Box
                      key={index}
                      display={"flex"}
                      flexDirection={"row"}
                      gap={1}
                    >
                      <TextIntegrationStyle
                        key={index}
                        title={""}
                        value={tag}
                      />
                    </Box>
                  ))}
            </Box>
          </Box>
        ))}
      </Box>
    )
  );
};

export default TagsHostView;
